var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5542 6.74003L7.17123 2.83503C6.78123 2.38503 6.06623 2.38703 5.61323 2.84103L2.83123 5.62803C2.00323 6.45703 1.76623 7.68803 2.24523 8.67503C5.10685 14.6 9.88528 19.3851 15.8062 22.255C16.7922 22.734 18.0222 22.497 18.8502 21.668L21.6582 18.855C22.1132 18.4 22.1142 17.681 21.6602 17.291L17.7402 13.926C17.3302 13.574 16.6932 13.62 16.2822 14.032L14.9182 15.398C14.8484 15.4712 14.7565 15.5195 14.6566 15.5354C14.5567 15.5513 14.4543 15.5339 14.3652 15.486C12.1357 14.2021 10.2862 12.3503 9.00523 10.119C8.95726 10.0298 8.93989 9.92726 8.95578 9.82719C8.97168 9.72711 9.01996 9.63502 9.09323 9.56503L10.4532 8.20403C10.8652 7.79003 10.9102 7.15003 10.5542 6.73903V6.74003Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9f18562199c47599703a1b456423e5ac.svg";
export { ForwardRef as ReactComponent };